<template>
  <div
    v-if="isBatchSearch && batch"
    class="traceability-search-batch"
  >
    <div class="traceability-search-batch-col">
      <header class="traceability-search-batch-header">
        <div class="traceability-search-batch-header-heading">
          <div>
            <div class="traceability-search-batch-title">{{ batch.lotId }}</div>

            <small class="traceability-search-batch-updated-at">
              Busca realizada <b>{{ updatedAtFormatted }}</b>
            </small>
          </div>

          <div v-if="batch.typeTemperatura">
            <img :src="getTypeTemperatura" alt="">
          </div>
        </div>

        <div
          v-if="batch.menemonico"
          class="traceability-search-batch-header-key-value"
        >
          <div class="traceability-search-batch-header-key-value-key">Lote:</div>

          <div class="traceability-search-batch-header-key-value-value">
            <div class="mnemonic-badge">{{ batch.menemonico }}</div>
          </div>
        </div>
      </header>

      <hr class="traceability-search-batch-divider" />

      <div class="traceability-search-batch-info">
        <div class="traceability-search-batch-info-samples">
          <div class="traceability-search-batch-info-samples-icon">
            <svg-loader
              src="/static/images/icon-traceability-event-EM_TRANSITO.svg"
              alt="Amostras"
            />
          </div>

          <div
            v-if="batch.totalSamples != null"
            class="traceability-search-batch-info-samples-content"
          >
            <div class="traceability-search-batch-info-label">
              Total de amostras
            </div>

            <div class="traceability-search-batch-info-value">
              {{ batch.totalSamples }}
            </div>
          </div>
        </div>

        <div
          v-if="batch.temperature"
          class="traceability-search-batch-info-temperature"
        >
          <div class="traceability-search-batch-info-label">
            Temperatura
          </div>

          <div class="traceability-search-batch-info-value">
            {{ batch.temperature }}°
          </div>
        </div>
      </div>

      <div
        v-if="batch.photo"
        class="traceability-search-batch-picture"
      >
        <button
          class="btn btn-primary exibeLote"
          @click="openFotoModal()"
        >
          FOTO DO LOTE

          <svg-loader
            src="/static/images/rastreio-pesquisa/icon-visibiliy.svg"
            class="traceability-results-item-footer-button-icon"
          />
        </button>

        <modal
          ref="traceabilityFoto"
          :icon-enabled="false"
          :close-button-enabled="true"
          title="FOTO DO LOTE"
          template="question"
          first-button-text="Voltar"
          first-button-style="btn-quarternary"
          :hide-second-button="true"
          :hide-first-button="true"
          ref-name="traceabilityFoto"
          @first-cta="closeFotoModal()"
          @close="closeFotoModal()"
        >
          <iframe 
            :src="batch.photo"
            height="400"
            frameborder="0"
            sandbox="allow-same-origin allow-scripts"
            style="transform: scale(1); transform-origin: 0 0;"
            class="traceability-search-batch-picture-image">
          </iframe>
        </modal>

        
      </div>
    </div>

    <div class="traceability-search-batch-main-col">
      <traceability-events-stepper :events="batch.eventList" :current-status="batch.currentStatus" />

      <div>
        <traceability-maps
          :current-status="batch.currentStatus"
          :o-s-alvaro="batch.codeOS"
          :locations="mapLocations"
          :laboratory="{
            name: batch.laboratory.name,
            address: batch.laboratory.address,
          }"
          :nto="{
            name: batch.nto.destination,
            address: batch.nto.address,
          }"
          :current-location="{
            address: batch.lotLocation?.address,
            position: {
              lat: Number(batch.lotLocation?.latitude),
              lng: Number(batch.lotLocation?.longitude),
            },
            lastUpdated: batch.lotLocation?.lastUpdated,
          }"
          :last-update-text="updatedAtFormatted"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'

import { getBatchSearchDetailsByBarcode } from '@/api/traceability'
import notify from '@/api/notification'

import { TRACEABILITY_SEARCH_BATCH } from '@/enums'

import { ONE_SECOND_IN_MILLISECONDS } from '@/constants'

import TraceabilityMaps from '@/components/common/TraceabilityMaps'

import TraceabilityEventsStepper from './TraceabilityEventsStepper'

export default {
  name: 'TraceabilitySearchBatch',
  components: {
    TraceabilityEventsStepper,
    TraceabilityMaps,
  },
  filters: {
    date(value) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    }
  },
  data() {
    return {
      batch: null,
      updatedAt: null,
      updatedAtFormatted: undefined,
      updatedAtAutoFormatterInterval: undefined
    }
  },
  computed: {
    getTypeTemperatura(){
      switch(batch.typeTemperatura) {
        case "Congelado":
            return "/static/images/rastreio-pesquisa/icon-congelado.png";
        case "Refrigerado":
            return "/static/images/rastreio-pesquisa/icon-refrigerado.png";
        case "Ambiente":
            return "/static/images/rastreio-pesquisa/icon-ambiente.png";
        case "37ºC":
            return "/static/images/rastreio-pesquisa/icon-37.png";
        case "Refrigerado/Congelado":
            return "/static/images/rastreio-pesquisa/icon-refrigerado-congelado.png";
        case "Ambiente(Lâmina) Refrigerado (Secreção)":
            return "/static/images/rastreio-pesquisa/icon-ambiente-refrigerado.png";
        case "Variável":
            return "/static/images/rastreio-pesquisa/icon-variavel.png";
        case "Refrigerado Seco":
            return "/static/images/rastreio-pesquisa/icon-refrigerado-seco.png";
        default:
            return ``;
      }
    },
    searchQueryParamsKey() {
      return `${this.$route.query.typeOfSearch}_${this.$route.query.q}`
    },
    isBatchSearch() {
      return this.$route.query.typeOfSearch === TRACEABILITY_SEARCH_BATCH && this.$route.query.q
    },
    mapLocations() {
      return [
        {
          name: 'laboratory',
          icon: this.batch.laboratory?.icon || 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-lab.png',
          position: {
            lat: Number(this.batch.laboratory?.latitude),
            lng: Number(this.batch.laboratory?.longitude)
          },
        },
        {
          name: 'transport',
          icon: 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-in-transit.png',
          position: {
            lat: Number(this.batch.lotLocation?.latitude),
            lng: Number(this.batch.lotLocation?.longitude),
          },
        },
        {
          name: 'placeExecution',
          icon: this.batch.nto?.icon || 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-alvaro.png',
          position: {
            lat: Number(this.batch.nto?.latitude),
            lng: Number(this.batch.nto?.longitude)
          },
        },
      ]
    }
  },
  watch: {
    searchQueryParamsKey: {
      handler() {
        if (this.isBatchSearch) {
          this.handleGetDetails()
        }
      },
      immediate: true,
    },
    /** @todo Remove this watch. */
    batch: {
      handler() {
        console.log('batch', this.batch)
      },
    },
  },
  mounted() {
    this.createUpdatedAtAutoFormatter()
  },
  beforeDestroy() {
    this.destroyUpdatedAtAutoFormatter()
  },
  methods: {
    openFotoModal() {
      this.$refs.traceabilityFoto.open()
    },
    closeFotoModal() {
      this.$refs.traceabilityFoto.close()
    },
    async handleGetDetails() {
      this.batch = await this.fetchDetails()
      this.updatedAt = new Date()
      console.log(this.mapLocations);
    },
    async fetchDetails() {
      try {
        const response = await getBatchSearchDetailsByBarcode(this.$route.query.q)

        return response.data
      } catch (error) {
        console.error('Error fetching batch details:', error)

        notify({
          title: 'Erro',
          message: 'Ocorreu um problema inesperado ao buscar detalhes do lote.',
        })
      }
    },
    updateFormattedUpdatedAt() {
      this.updatedAtFormatted = moment(this.updatedAt).fromNow()
    },
    createUpdatedAtAutoFormatter() {
      this.updateFormattedUpdatedAt()

      this.updatedAtAutoFormatterInterval = setInterval(() => {
        this.updateFormattedUpdatedAt()
      }, ONE_SECOND_IN_MILLISECONDS)
    },
    destroyUpdatedAtAutoFormatter() {
      clearInterval(this.updatedAtAutoFormatterInterval)
    }
  }
}
</script>

<style lang="scss" scoped>
.traceability-search-batch {
  display: flex;
  gap: 1.5rem;
  border-radius: 0.375rem;
  padding: 1.5rem;
  background-color: #FFFFFF;
  margin-bottom: 1rem;
  font-family: "Exo 2";

  .exibeLote {
    width: 100%;
  }

  &-col {
    max-width: 280px;
  }

  &-main-col {
    flex: 1;
  }

  &-header {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    &-heading {
      display: flex;
      gap: 1rem;
    }

    &-key-value {
      display: flex;
      align-items: center;
      gap: 0.25rem;

      &-key {
        text-transform: uppercase;
        font-weight: 700;
        font-size: 0.75rem;
        color: #818181;
      }
    }
  }

  &-title {
    font-family: "Roboto";
    font-weight: 400;
    font-size: 1.375rem;
    color: #7F1A54;
  }

  &-updated-at {
    font-weight: 400;
    font-size: 0.75rem;
    color: #999999;
  }

  &-divider {
    border: none;
    border-top: 1px solid #CCCCCC;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  &-info {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    margin-bottom: 1rem;

    &-label {
      font-weight: 600;
      font-size: 0.75rem;
      text-transform: uppercase;
      color: #818181;
      margin-bottom: 0.25rem;
    }

    &-value {
      font-weight: 700;
      font-size: 1.75rem;
    }

    &-samples {
      display: flex;
      gap: 8px;
      align-items: center;

      &-icon {
        ::v-deep(.md-icon) {
          width: 40px;
          height: 40px;
          min-width: auto;
          min-height: auto;
          color: #52CC9C;
        }
      }

      &-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }
    }

    &-samples &-value {
      color: #52CC9C;
    }

    &-temperature {
      text-align: right;
    }

    &-temperature &-value {
      color: #7399E5;
    }
  }

  &-picture {
    &-label {
      font-weight: 600;
      font-size: 0.75rem;
      text-transform: uppercase;
      color: #7F1A54;
      margin-bottom: 0.5rem;
    }

    &-image {
      width: 100%;
      height: 100%;
      max-width: 100%;
      object-fit: cover;
      border-radius: 0.375rem;
    }
  }
}

.mnemonic-badge {
  font-family: "Exo 2";
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  background-color: #404040;
  color: #FFFFFF;
  padding: 0.125rem 0.5rem;
  border-radius: 0.125rem;
  display: inline-flex;
}

</style>
<style lang="scss">

#traceabilityFoto .md-dialog {
  width: 90%;
  max-width: 870px;

  .standard-modal__title {
    font-family: 'Exo 2', sans-serif !important;
    font-style: bold;
    font-size: 20px;
    line-height: 26px;
    color: #7f1a54;
  }

  iframe {
    height: 400px !important;
  }

  .standard-modal__container-cta {
    padding-top: 1em;
  }
}

</style>
